import React, { useState } from 'react';
import { useNavigate } from "react-router-dom";
import { motion, AnimatePresence } from 'framer-motion';
import Button from "../ui/button";
import { ArrowRight, Play, Phone, Menu, X } from 'lucide-react';

export default function Hero({ onGetQuote }) {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const navigate = useNavigate();
  // ✅ Smooth scroll function
  const scrollToSection = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth" });
    setMobileMenuOpen(false);
  };


  return (
    
    <section className="relative min-h-screen flex items-center overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0 z-0">
        <img
          src="https://images.unsplash.com/photo-1600210492486-724fe5c67fb0?w=1920&q=80"
          alt="Luxury Interior"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-[#2C2C2C]/95 via-[#2C2C2C]/80 to-[#2C2C2C]/60 md:from-[#2C2C2C]/90 md:via-[#2C2C2C]/70 md:to-transparent" />
      </div>

      {/* Navigation */}
      <nav className="absolute top-0 left-0 right-0 z-50 py-2 md:py-3 px-4 sm:px-6 md:px-16">
        <div className="max-w-7xl mx-auto flex items-center justify-between">
          {/* Logo */}
          {/* Logo */}
        <motion.div
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          className="flex items-center"
        >
          <button onClick={() => navigate("/")} className="cursor-pointer">
            <img
              src="/logo.png"
              alt="Veda Creation & Group"
              className="h-16 md:h-20 lg:h-24 w-auto object-contain"
            />
          </button>
        </motion.div>

          {/* Desktop Navigation */}
          <motion.div
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.1 }}
          className="hidden lg:flex items-center gap-10"
        >

          <button onClick={() => scrollToSection("home")} className="nav-link">
            Home
          </button>

          <button onClick={() => scrollToSection("services")} className="nav-link">
            Services
          </button>

          {/* Projects Dropdown */}
          <div className="relative group">

            <span className="cursor-pointer nav-link">
              Projects
            </span>

            <div className="absolute left-0 top-8 hidden group-hover:block bg-[#2C2C2C]/95 backdrop-blur-md border border-white/10 rounded-md overflow-hidden min-w-[220px] shadow-lg">

              <button
                onClick={() => navigate("/projects/ongoing")}
                className="dropdown-item"
              >
                Ongoing Projects
              </button>

              <button
                onClick={() => navigate("/projects/completed")}
                className="dropdown-item"
              >
                Completed Projects
              </button>

              <button
                onClick={() => navigate("/projects/upcoming")}
                className="dropdown-item"
              >
                Upcoming Projects
              </button>

            </div>
          </div>

          <button onClick={() => scrollToSection("portfolio")} className="nav-link">
            Portfolio
          </button>

          <button onClick={() => scrollToSection("about")} className="nav-link">
            About
          </button>

          <button onClick={() => scrollToSection("contact")} className="nav-link">
            Contact
          </button>

        </motion.div>
          {/* Desktop Contact & CTA */}
          <motion.div
            initial={{ opacity: 0, y: -20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.2 }}
            className="hidden md:flex items-center gap-4 lg:gap-6"
          >
            {/* Phone Number with Blink Effect */}
           <motion.a
              href="tel:+918796063801"
              className="hidden lg:flex items-center gap-3 px-4 py-2 rounded-full bg-white/10 backdrop-blur-md border border-white/20 text-white font-semibold tracking-wide text-sm shadow-md"
              animate={{
                scale: [1, 1.05, 1],
              }}
              transition={{
                duration: 1.5,
                repeat: Infinity,
                ease: "easeInOut",
              }}
            >
              {/* Pulse Dot */}
              <span className="relative flex h-3 w-3">
                <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-green-400 opacity-75"></span>
                <span className="relative inline-flex rounded-full h-3 w-3 bg-green-500"></span>
              </span>

              {/* Icon */}
              <Phone className="w-4 h-4 text-green-400" />

              {/* Number */}
              <span className="text-white text-base tracking-wide">
                +91 87960 63801
              </span>
            </motion.a>

            {/* Get Quote Button */}
            <button
              type="button"
              onClick={onGetQuote}
              className="bg-black text-white px-4 lg:px-6 py-2 lg:py-3 rounded-md hover:bg-gray-900 transition text-sm"
            >
              Get Free Quote
            </button>
          </motion.div>

          {/* Mobile Menu Button */}
          <motion.button
            initial={{ opacity: 0, y: -20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.2 }}
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            className="md:hidden text-white p-2"
          >
            {mobileMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </motion.button>
        </div>

        {/* Mobile Menu */}
        <AnimatePresence>
          {mobileMenuOpen && (
            <motion.div
              initial={{ opacity: 0, height: 0 }}
              animate={{ opacity: 1, height: 'auto' }}
              exit={{ opacity: 0, height: 0 }}
              transition={{ duration: 0.3 }}
              className="md:hidden mt-4 bg-[#2C2C2C]/95 backdrop-blur-md border border-white/10 rounded-lg overflow-hidden"
            >
              <div className="flex flex-col p-4 space-y-3">
                <button onClick={() => scrollToSection("home")} className="nav-link">Home</button>
                <button onClick={() => scrollToSection("services")} className="nav-link">Services</button>

                  <div className="border-b border-white/10 pb-2">
                    <p className="text-white/60 text-sm mb-2">Projects</p>

                    <button
                      onClick={() => {
                        navigate("/projects/ongoing");
                        setMobileMenuOpen(false);
                      }}
                      className="block py-1 text-white/80 text-sm text-left w-full"
                    >
                      Ongoing Projects
                    </button>

                    <button
                      onClick={() => {
                        navigate("/projects/completed");
                        setMobileMenuOpen(false);
                      }}
                      className="block py-1 text-white/80 text-sm text-left w-full"
                    >
                      Completed Projects
                    </button>

                    {/* <a href="/projects/completed" className="block py-1 text-white/80 text-sm">
                      Completed Projects
                    </a> */}

                    <button
                      onClick={() => {
                        navigate("/projects/upcoming");
                        setMobileMenuOpen(false);
                      }}
                      className="block py-1 text-white/80 text-sm text-left w-full"
                    >
                      Upcoming Projects
                    </button>

                    {/* <a href="/projects/upcoming" className="block py-1 text-white/80 text-sm">
                      Upcoming Projects
                    </a> */}
                  </div>

                  <a href="#portfolio" className="text-white/80 py-2">Portfolio</a>
                  <a href="#about" className="text-white/80 py-2">About</a>
                  <a href="#contact" className="text-white/80 py-2">Contact</a>
                 
                
                <a
                  href="tel:+917001307267"
                  className="flex items-center gap-2 text-[#C9A962] font-medium tracking-wide text-sm py-2"
                >
                  <Phone className="w-4 h-4" />
                  +91 70013 07267
                </a>

                <button
                  type="button"
                  onClick={() => {
                    onGetQuote();
                    setMobileMenuOpen(false);
                  }}
                  className="bg-[#C9A962] text-white px-4 py-3 rounded-md hover:bg-[#b8954f] transition text-sm font-medium w-full"
                >
                  Get Quote
                </button>
              </div>
            </motion.div>
          )}
        </AnimatePresence>
      </nav>

      {/* Hero Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 md:px-16 pt-40 sm:pt-44 md:pt-48 lg:pt-50 pb-32 sm:pb-36 md:pb-40 lg:pb-48">
        <div className="max-w-5xl">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.3 }}
            className="flex items-center gap-2 md:gap-3 mb-4 md:mb-6"
          >
            <div className="w-8 md:w-12 h-[1px] bg-[#C9A962]" />
            <span className="text-[#C9A962] tracking-[0.2em] md:tracking-[0.3em] text-[10px] md:text-xs uppercase">Interior Design Studio</span>
          </motion.div>

          <motion.h1
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.4 }}
            className="font-serif text-3xl sm:text-4xl md:text-5xl lg:text-7xl text-white leading-tight mb-4 md:mb-6"
          >
            Designing Spaces That Reflect{' '}
            <span className="text-[#C9A962] italic block sm:inline mt-1 sm:mt-0">Your Lifestyle</span>
          </motion.h1>

          <motion.p
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.5 }}
            className="text-white/70 text-base sm:text-lg md:text-xl leading-relaxed mb-6 md:mb-10 max-w-xl"
          >
            From smart layouts to luxury interiors, Veda Creation & Group delivers end-to-end interior design solutions tailored to your vision.
          </motion.p>

          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.6 }}
            className="flex flex-col sm:flex-row gap-3 md:gap-4"
          >
            <Button className="bg-[#C9A962] hover:bg-[#b8954f] text-white rounded-none px-6 md:px-8 py-4 md:py-6 text-sm md:text-base group w-full sm:w-auto justify-center">
              Get Free Consultation
              <ArrowRight className="ml-2 w-4 h-4 group-hover:translate-x-1 transition-transform" />
            </Button>
            <Button variant="outline" className="border-white/30 text-white hover:bg-white/10 rounded-none px-6 md:px-8 py-4 md:py-6 text-sm md:text-base w-full sm:w-auto justify-center">
              <Play className="mr-2 w-4 h-4" />
              View Our Work
            </Button>
          </motion.div>
        </div>
      </div>

      {/* Stats Bar */}
      <motion.div
        initial={{ opacity: 0, y: 50 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.8 }}
        className="absolute bottom-0 left-0 right-0 bg-white/10 backdrop-blur-md border-t border-white/10"
      >
        <div className="max-w-7xl mx-auto px-4 sm:px-6 md:px-16 py-6 md:py-8 grid grid-cols-2 md:grid-cols-4 gap-4 sm:gap-6 md:gap-8">
          {[
            { number: '50+', label: 'Projects Completed' },
            { number: '7+', label: 'Years Experience' },
            { number: '5+', label: 'Design Experts' },
            { number: '98%', label: 'Client Satisfaction' },
          ].map((stat, i) => (
            <div key={i} className="text-center">
              <div className="font-serif text-2xl sm:text-3xl md:text-4xl text-[#C9A962] mb-1">{stat.number}</div>
              <div className="text-white/60 text-xs sm:text-sm tracking-wide">{stat.label}</div>
            </div>
          ))}
        </div>
      </motion.div>
    </section>
  );
}